import { IProduct } from "@faire/web-api/indigofair/data/IProduct";
import React from "react";

import { NotifyMeBackInStockButton } from "./NotifyMeButton";
import { NotifyMeProps } from "./NotifyMeProps";

interface IProps {
  data: NotifyMeProps;
}

export const NotifyMe: React.FC<IProps> = ({ data }) => {
  const isSalesPaused = data.productState === IProduct.State.SALES_PAUSED;

  if (!isSalesPaused || data.productOptionToken === undefined) {
    return null;
  }
  return (
    <NotifyMeBackInStockButton
      productOptionToken={data.productOptionToken}
      productToken={data.productToken}
      productState={data.productState}
    />
  );
};
